import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-project-details-card',
  templateUrl: './project-details-card.component.html',
  styleUrls: ['./project-details-card.component.scss','../../../../mystery-shopper/mystery-shopper.component.scss']
})
export class ProjectDetailsCardComponent {

  @Input() project: any;
  @Input() channels: any[] = []
  @Input() branches: any[] = []
}
